<template>
  <header class="container-fluid h-100 d-flex flex-column p-0 sidebar-container">
    <!-- Logo Section -->
    <div
      class="d-flex align-items-center justify-content-center py-3 mb-4 border-bottom border-opacity-25"
    >
      <img :src="logo" alt="Logo SaveMyMoney" width="200" class="logo-img rounded-1" />
    </div>

    <!-- Navigation Section -->
    <nav class="flex-grow-1 px-3" role="navigation" aria-label="Navigation principale">
      <ul class="list-unstyled">
        <li
          v-for="(url, index) in listeUrl"
          :key="index"
          class="sidebar-nav-item"
          :class="{ 'mt-auto': listeUrl.length - 1 === index }"
        >
          <router-link
            :to="{ name: url.name }"
            :aria-label="url.text"
            :aria-current="
              $route.name === url.name ||
              ($route.name === 'details-categorie' && url.name === 'categories')
                ? 'page'
                : undefined
            "
            class="nav-link text-decoration-none d-flex align-items-center py-3 px-4 rounded-3 transition-all"
            :class="{
              'active-link': $route.name === 'details-categorie' && url.name === 'categories'
            }"
            activeClass="active-link"
          >
            <font-awesome-icon
              :icon="`fa-solid fa-${url.icon}`"
              class="nav-icon me-3"
              size="lg"
              aria-hidden="true"
            />
            <span class="nav-text">{{ url.text }}</span>
          </router-link>
        </li>
      </ul>

      <div id="btn-add-new-depense" class="w-100">
        <button
          class="btn rounded-5 glass-btn-success w-100 d-flex align-items-center justify-content-center"
          aria-label="Ajouter un nouveau revenu ou dépense"
          @click="modalAddContent.show = true"
        >
          <font-awesome-icon icon="fa-solid fa-plus" size="xl" />
          <div class="fw-bold ms-2">Ajouter</div>
        </button>
      </div>
    </nav>
  </header>
</template>

<script>
// Store
import modalAddContentStore from '@/stores/components/modalAddContent'

// Global
import logo from '@/assets/logo.png'

export default {
  name: 'SideBarBlock',

  setup() {
    const modalAddContent = modalAddContentStore()
    return { modalAddContent }
  },

  data() {
    return {
      logo: logo,
      listeUrl: [
        { name: 'home', text: 'Tableau de bord', icon: 'chart-line' },
        { name: 'categories', text: 'Catégories', icon: 'tags' },
        { name: 'recurrences', text: 'Récurrences', icon: 'rotate' },
        { name: 'compte', text: 'Compte', icon: 'user' }
      ]
    }
  },

  computed: {
    currentRoute() {
      return this.$route.name
    }
  }
}
</script>
